<template>

  <div class="card-base card-shadow--medium widget small-widget queue-widget">
    <div class="widget-value ph-10">
      <div class="flex mb-10 mt-10 align-center">
        <span class="mr-5 flex justify-center align-center">
          <v-svg width="18" height="18" class="voxo-green" sprite="queue"/>
        </span>
        <el-input
          class="widget-name-input ml-10"
          v-model="widgetName"
        />
        <el-button
          @click="removeWidget"
          class="table-action-button ml-10"
        >
          <i class="el-icon-delete voxo-dark-red" />
        </el-button>
      </div>
    </div>

    <div class="ph-10 flex">
      <el-input
        class="widget-search-input"
        v-model="searchText"
        placeholder="Search queue"
        clearable
        style="margin-right: 0;"
      >
        <template slot="prefix">
          Queue
        </template>
      </el-input>
    </div>

    <div class="table-widget-table ph-10">
      <vxe-grid
        round
        height="100%"
        border="inner"
        ref="xGrid"
        class="user-stats-table"
        empty-text="No Data"
        auto-resize
        :show-overflow="true"
        :scroll-y="{enabled: true, gt: 25, oSize: 0}"
        :sort-config="{defaultSort: {field: 'talkTime', order: 'desc'}}"
        :data="tableData"
        :columns="tableColumns"
      />
    </div>

  </div>

</template>

<script>

import {mapGetters} from "vuex";
import {debounce} from 'lodash';
import {phoneNumberFormatter} from "@/globals/globals";

export default {
  name: 'QueueActiveTable',
  props: {
    widgetIndex: {required: true},
    title: {required: true},
    queueNameKey: {required: true},
    columnFields: {required: true},
  },
  data() {
    return {
      widgetName: this.title,
      searchText: '',
      filter: '',
      viewStyle: 'default',
      tableColumns: [
        {
          field: 'queueId',
          title: 'Queue',
          minWidth: 175,
          sortable: true,
          formatter: this.getQueueName,
        },
        {
          field: 'connectedAgent',
          title: 'Agent',
          minWidth: 175,
          sortable: true,
          formatter: this.agentNameFormatter
        },
        {
          field: 'talkTime',
          title: 'Duration',
          minWidth: 100,
          sortable: true,
          sortBy: (data) => data.talkTime,
          formatter: this.timeFormatter
        },
        {
         field: 'callerName',
         title: 'Name',
         minWidth: 175,
         sortable: true
        },
        {
          field: 'callerNum',
          title: 'Phone',
          minWidth: 175,
          formatter: this.numberFormatter
        },
      ]
    }
  },
  computed: {

    ...mapGetters('queueDashWaiting', {waitingCallData: 'list'}),
    ...mapGetters('queueDashActive', {activeCallData: 'list'}),

    tableData() {

      if(this.filter) {
        return this.activeCallData.filter(item => {
          return this.queueNameKey[item.queueId].toLowerCase().includes(this.filter.toLowerCase());
        });
      }

      return this.activeCallData;
    },

  },
  watch: {
    searchText: debounce(function () {
      this.filter = this.searchText;
    }, 250),
    widgetName: debounce(function() {
      if(this.widgetName === this.title) return;
      this.$emit('nameUpdate', {name: this.widgetName, index: this.widgetIndex});
    }, 750)
  },
  methods: {

    getQueueName(data) {
      const { cellValue } = data;
      return this.queueNameKey[cellValue] ? this.queueNameKey[cellValue] : 'Unknown';
    },

    numberFormatter(data) {
      const { cellValue: number } = data;
      return phoneNumberFormatter(number);
    },

    agentNameFormatter(data) {
      const { cellValue: name } = data;

      return name ? name.replace(/_/g, ' ') : name;
    },

    //input is time in seconds. output is pretty time.
    timeFormatter(data) {
      const { cellValue: time } = data;
      const hours = Math.floor(time / 3600);
      const remainderSeconds = time % 3600;
      const minutes = Math.floor(remainderSeconds / 60);
      const seconds = Math.round(remainderSeconds % 60);

      if (hours > 0) {return hours + 'hr ' + minutes + 'm';}
      if (minutes > 0) {return minutes + 'm ' + seconds + 's';}
      if (seconds > 0) {return seconds + 's';}
      return '0';
    },

    removeWidget(){
      this.$emit('removeWidget', this.widgetIndex);
    },

  }
}

</script>
